<!--
 * @Author: your name
 * @Date: 2020-06-29 16:10:51
 * @LastEditTime: 2020-08-10 09:54:30
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \heating-wechat-web\src\components\Index\Index.vue
--> 
<template>
  <div class="warranty-wrap"
    v-loading="loading"
    element-loading-text="正在查询您的报修记录，请稍等">
    <div class="warranty-content">
      <div class="warranty-back"></div>
      <div class="warranty-top">
        <div>报修人信息</div>
        <div>卡号</div>
        <div style="border-bottom:solid 1px #dddddd;padding-bottom:0.05rem;"><input type="text" placeholder="请输入供暖卡号" v-model="cardCode"></div>
        <div>姓名</div>
        <div style="border-bottom:solid 1px #dddddd;padding-bottom:0.05rem;"><input type="text" placeholder="请输入姓名" v-model="userName"></div>
        <div>联系方式</div>
        <div style="border-bottom:solid 1px #dddddd;padding-bottom:0.05rem;"><input type="text" placeholder="请输入手机号码" v-model="phone"></div>
      </div>
      <div class="warranty-bottom">
        <div>报修内容</div>
        <div>报修类型</div>
        <div style="border-bottom:solid 1px #dddddd;padding-bottom:0.05rem;" @click="warrantyFlag = true"><input type="text" placeholder="请选择报修类型" v-model="warrantyType" readonly="readonly"><i class="iconfont iconxiala" style="font-size: 0.12rem;"></i></div>
        <div>报修内容</div>
        <div style="border-bottom:solid 1px #dddddd;padding-bottom:0.05rem;"><input type="text" placeholder="请输入报修内容" v-model="warrantyInfo"></div>
      </div>
      <div class="warranty-button">
        <div><el-button style="background: #007B83;color:#fff;border:none;padding:4%;font-size:0.16rem" @click="saveWarranty">确定</el-button></div>
        <div><el-button style="background: rgba(0,123,131,0.1);color: #007B83;border:1px solid #007B83;padding:4%;font-size:0.16rem" @click="goHome">取消</el-button></div>
        <div style="color: #007B83;" @click="getWarrantyRecord">报修记录</div>
      </div>
      <div class="mark-maintain" v-if="warrantyFlag">
        <div>
          <div class="mark-btn">
            <div @click="warrantyFlag = false;" style="color:#999999">取消</div>
            <div @click="warrantyFlag = false;" style="color: #007B83;">确定</div>
          </div>
          <div class="warranty-type">
            <div  v-for="(item,index) in warrantyTypeData" :key="index" >
              <div :class="item.checkFlag ? 'warrantCheckName': 'warrantOutcheckName'">{{item.maintain_type}}</div>
              <div v-if="item.checkFlag"  style="width: 0.2rem;height:0.2rem" @click="checkWarrantyType(item.maintain_type,item.type_id,index,false)">
                <i class="iconfont iconxuanze2" style="color: #21326D;font-size:0.2rem"></i>
              </div>
              <div v-else style="width: 0.2rem;height:0.2rem" @click="checkWarrantyType(item.maintain_type,item.type_id,index,true)">
                <img src="../../assets/image/outcheck-icon.png" style="width: 100%;height:100%;" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mark-hint" v-if="markFlag">
        <div>
          <div style="text-align: right;padding:0.1rem 0.15rem;color:#AAAAAA"><i class="iconfont iconguanbi" @click="markFlag = false"></i></div>
          <div style="color:#007B83;margin-top:0.14rem">
            <div>
              <div>{{textHint}}</div>
              <div>请重新检查您的信息~</div>
            </div>
          </div>
        </div>
      </div>
      <div class="mark-result" v-if="markResult">
        <!-- 成功 -->
        <div class="mark-result-box" v-if="resultFlag">
          <div style="text-align: right;padding-bottom:0.1rem;color:#AAAAAA"><i class="iconfont iconguanbi" ></i></div>
          <div><img src="../../assets/image/warrantySuccess.png" alt="" style="margin:0 auto;"></div>
          <div style="text-align: center;color:#007B83;margin:0.2rem 0rem">
            <div>恭喜您，报修申请已提交成功！</div>
            <div>请等待工作人员处理，</div>
            <div>处理进度可在报修记录查看</div>
          </div>
          <div style="text-align: center;">
            <el-button style="background:#007B83;color:#fff;border:none;padding:4%;" @click="goHome">确定</el-button>
          </div>
        </div>
        <!-- 失败 -->
        <div class="mark-result-box" v-else>
          <div style="text-align: right;padding-bottom:0.1rem;color:#AAAAAA"><i class="iconfont iconguanbi" ></i></div>
          <div><img src="../../assets/image/warrantyFail.png" alt="" style="margin:0 auto;"></div>
          <div style="text-align: center;color:#007B83;margin:0.2rem 0rem">抱歉，您的在线报修失败</div>
          <div style="text-align: center;margin-top:0.3rem">
            <el-button style="background:#007B83;color:#fff;border:none;padding:4%;" @click="goHome">再次报修</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
export default {
  name: 'warranty',
  data(){
    return{
      phone:'',
      userName:'',
      cardCode:'',//卡号
      loading:true,
      markFlag:false,// 提示信息弹窗
      markResult:false,// 报修结果弹窗
      warrantyFlag:false,// 报修类型弹窗
      resultFlag:'',// 报修成功
      warrantyTypeData:[],// 可选择的报修类型
      textHint:'',// 提示消息
      typeId:'',// 用户选择的类型id
      warrantyType:'',// 用户选择的报修类型
      warrantyInfo:'',// 用户填写的报修信息
      
    }
  },

  methods:{
    // 获取报修类型
    async getWarrantyType(){
      const res = await this.$http.get(`${this.$url.globalurl}/wxWarranty`,{
          data:{
            warrantyType:true
          }
      });
      res.result.forEach(i=>{
        i.checkFlag = false;
      })
      this.warrantyTypeData = res.result;
      this.loading = false;
    },
    // 勾选报修类型
    checkWarrantyType(typeName,typeId,index,flag){
      for(let i = 0; i < this.warrantyTypeData.length; i++){
        this.warrantyTypeData[i].checkFlag = false;
        this.warrantyTypeData[index].checkFlag = flag;
      }
      this.typeId = typeId;
      flag ? this.warrantyType = typeName : this.warrantyType = '';
    },
    // 报修
    async saveWarranty(){
      if(!this.cardCode){
        this.markFlag = true;
        return this.textHint = '抱歉，您的供热卡号未填写~';
      }
      if(!this.userName){
        this.markFlag = true;
        return this.textHint = '抱歉，您的姓名未填写~';
       }
      if(!this.phone){
        this.markFlag = true;
        return this.textHint = '抱歉，您的电话号码未填写~';
      }
      if(!this.warrantyType){
        this.markFlag = true;
        return this.textHint = '抱歉，您的报修类型未选择~';
      }
      if(!this.warrantyInfo){
        this.markFlag = true;
        return this.textHint = '抱歉，您的报修内容未填写~';
      }
      if(!this.cardCode){
        this.markFlag = true;
        return this.textHint = '抱歉，您的供热卡号未填写~';
      }
      // 正则
      if(!(/^[\u4E00-\u9FA5]{2,4}$/.test(this.userName))){
        this.markFlag = true;
        return this.textHint = '抱歉，您的姓名填写错误';
      }
      if(!(/^1[3456789]\d{9}$/.test(this.phone))){
        this.markFlag = true;
        return this.textHint = '抱歉，您的电话号码错误';
      }
      const res = await this.$http.post(`${this.$url.globalurl}/wxWarranty`,{
        submit_time:moment().format('YYYY-MM-DD HH:mm:ss'),
        heating_card_num:this.cardCode,
        maintain_type_id:this.typeId,
        maintain_content:[this.warrantyInfo],
        maintain_name:this.userName,
        maintain_phone:this.phone,
        abnormal_status:1,
      });
      if(res.code === 200){
        this.markResult = true;
        this.resultFlag = true;
      }else{
        this.markResult = true;
        this.resultFlag = false;
      }
    },
    // 查询报修记录
    async getWarrantyRecord(){
      this.$router.push({
        name:'warrantyRecord'
      })
    },
    // 取消
    goHome(){
      this.$router.push({
        name:'index'
      })
    },
    },

  mounted(){
    this.getWarrantyType();
    document.title = '在线报修';
  }
}
</script>
<style lang='scss' scoped>
@import url(warranty.scss);
</style>
